import { render, staticRenderFns } from "./TopIntegrations.vue?vue&type=template&id=7897c3a4&"
import script from "./TopIntegrations.vue?vue&type=script&lang=js&"
export * from "./TopIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./TopIntegrations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports